module.exports = __webpack_public_path__ + "img/icon-mouse.6f4993ce.svg";